import HeroLanding from "@/components/landing/HeroLanding";
import ProblemSection from "@/components/landing/ProblemSection";
import SolutionSection from "@/components/landing/SolutionSection";
import SuccessStories from "@/components/SuccessStories";
import DiagnosticSection from "@/components/landing/DiagnosticSection";


const LandingAhorro = () => {
  return (
    <main>
      <HeroLanding />
      <ProblemSection />
      <SolutionSection />
      {/* Casos de éxito (MISMO COMPONENTE QUE LA WEB) */}
      <SuccessStories />
      <DiagnosticSection />
    </main>
  );
};

export default LandingAhorro;